import React from 'react';
import ServiceCard from "./serviceCard";
import useServices from "../../../hooks/admin/useServices";
import {useNavigate} from "react-router-dom";
import PageLoader from "../../../components/pageLoader";

const Services = () => {
  const navigate = useNavigate();
  const {data, isLoading, error, remove} = useServices();

  if (isLoading) return <PageLoader/>;
  if (error) return null;
  return (
      <section className="services">
        <div className='custom-container'>
          <div className='content-section'>
            <h1 className='page-title'>Services</h1>
            <div className='content-body'>
              <div className="text-right pb-5 pb-lg-4">
                <button onClick={() => navigate("/admin/services/new")} className="add-btn">Add Service +</button>
              </div>
              <div className="row">
                {data?.map(service =>
                    <ServiceCard
                        key={service.id}
                        onDelete={remove}
                        service={service}
                    />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Services;
